













import Component from 'vue-class-component'
import {FormInputProps} from './IFormInput'

@Component
export default class FormInput extends FormInputProps {
    private componentClass = "FormInput"

    listener(event: string) {
        this.onChange(event)
    }

    onKeyUp(event: KeyboardEvent) {
        if (event.keyCode === 13 && this.onEnter !== undefined) {
            this.onEnter()
        }
    }
}
